import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@libs/redux/store';
import { clearApiError } from '@libs/redux/apiErrorSlice';
import { useAddSnackbarMessage } from '@shared/useAddSnackBar';

export const ApiErrorHandler = () => {
  const error = useAppSelector(state => state.apiError.error);
  const dispatch = useAppDispatch();
  const addSnackBarMessage = useAddSnackbarMessage();

  useEffect(() => {
    if (error) {
      addSnackBarMessage({ text: error.message, type: 'error' });
      dispatch(clearApiError());
    }
  }, [error]);

  return null;
};
